export const ModalStyles = {
    content: {
        right: 'auto',
        bottom: 'auto',
        width: '172px',
        padding: '0',
        borderRadius: '20px',
        boxShadow: '0 8px 16px 0 rgba(79, 115, 151, 0.17)',
        border: 'solid 1px #e1e8ee'
    }
}
